import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
import moment from 'moment';
import SearchComponent from '../../PricingHub/SearchComponent';

class VoiceTrafficByLdDistinationSearchForm extends SearchComponent {
  searchInputs = [
    {
      label: 'label.startDate',
      name: 'startDate',
      type: 'datetime',
      required: true,
      defaultValue: moment(). startOf('month').format('YYYY-MM-DD HH:mm:ss'),
    },
    {
      label: 'label.endDate',
      name: 'endDate',
      type: 'datetime',
      required: true,
      defaultValue: moment().endOf('month').format('YYYY-MM-DD HH:mm:ss'),
    },
    {
      label: 'label.location',
      name: 'sciudad',
    },
  ];

  btnSpan = 'col-md-3';
}

VoiceTrafficByLdDistinationSearchForm.propTypes = {
  onSubmit: PropTypes.func,
  isSubmitting: PropTypes.bool,
};

VoiceTrafficByLdDistinationSearchForm.defaultProps = {
  isSubmitting: false,
};

export default withTranslation('common')(VoiceTrafficByLdDistinationSearchForm);
